<template>
  <ul class="zxzt">
    <template v-for="item in list">
      <item :objItem="item"/>
    </template>
  </ul>
</template>

<script>
import item from "./item";
export default {
  components: {
    item
  },
  props:{
    list: Array,
  },
  data(){
    return{

    }
  },
  methods:{

  }
};
</script>

<style lang="scss" scoped>
.zxzt {
    display: flex;
    flex-wrap:wrap;
  }
</style>
